import { Button } from '@heycater/design-system';
import styled from 'styled-components';

const TransparentButton = styled(Button)`
  background-color: transparent;
  border: none;
  color: #3c4340;

  :hover {
    background-color: rgba(0, 0, 0, 0.07);
  }

  :active {
    background-color: rgba(0, 0, 0, 0.2);
  }
`;

export default TransparentButton;
